export class NameValuePairVO {
    name: string;
    value: string;
    constructor() {
    }
}
